module.exports = __webpack_public_path__ + "img/userIconWeavr.f31b56f1.svg";